// Key of a report job, or of the Current Day dashboard when there is no report
// id: caches the filter options and tags the loaded report data (dataTarget). String and numeric ids map to the same key.
export const makeFilterOptionsTargetKey = (reportId?: number | string, jobId?: number | string): string =>
  (reportId === undefined ? 'current' : `${reportId}/${jobId ?? ''}`);
